module.exports = __webpack_public_path__ + "media/images/partner-15-c319de24012621db3b6a9b45d1c055ea.png";